var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomAtomo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 371.7,
    height: 310.994,
    viewBox: "0 0 371.7 310.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#e32438;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-187.11 -238.162)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(187.61 238.683)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M512.6,548.656c-14.654,0-33.1-7.957-53.833-23.475-28.542-21.367-58.755-54.805-85.075-94.159s-45.7-80.045-54.553-114.579C309.8,280,313.371,254.087,329.208,243.5c31.361-20.991,100.033,28.521,156.345,112.7S561.4,522.743,530.035,543.723A30.719,30.719,0,0,1,512.6,548.656ZM346.9,249.895a20.026,20.026,0,0,0-11.352,3.076c-11.347,7.587-13.3,29.694-5.365,60.638,8.538,33.315,27.359,72.762,52.984,111.071s54.9,70.761,82.432,91.376c25.579,19.15,46.755,25.78,58.092,18.188,22.431-15.009,8.651-87.585-47.614-171.709C427.533,289.963,374.858,249.895,346.9,249.895Z",
    transform: "translate(-314.039 -238.683)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.104 2.389)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M340.713,548.546c-7.119,0-13.322-1.8-18.445-5.437-30.764-21.845-8.929-103.639,49.7-186.2h0c58.637-82.56,128.662-130.123,159.431-108.278s8.929,103.639-49.7,186.2c-27.415,38.6-58.55,71.182-87.673,91.741C373.422,541.113,355.177,548.546,340.713,548.546Zm40.552-185.036c-58.6,82.514-74.4,154.674-52.4,170.3,11.126,7.9,32.477,1.867,58.581-16.557,28.094-19.834,58.267-51.452,84.952-89.031,58.6-82.514,74.4-154.679,52.4-170.305S439.862,280.99,381.266,363.509Z",
    transform: "translate(-308.35 -243.328)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 87.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M368.207,543.638c-101.267,0-180.6-29.56-180.6-67.294s79.33-67.294,180.6-67.294,180.6,29.56,180.6,67.294S469.475,543.638,368.207,543.638Zm0-123.184c-101.206,0-169.194,28.9-169.194,55.891S267,532.234,368.207,532.234,537.4,503.338,537.4,476.344,469.418,420.453,368.207,420.453Z",
    transform: "translate(-187.61 -409.05)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 28.012,
    cy: 28.012,
    r: 28.012,
    transform: "translate(340.195 365.595)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 35.424,
    cy: 35.424,
    r: 35.424,
    transform: "translate(225.524 239.299)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 35.424,
    cy: 35.424,
    r: 35.424,
    transform: "translate(487.462 384.071)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 35.424,
    cy: 35.424,
    r: 35.424,
    transform: "translate(221.419 465.844)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomAtomo);
export default __webpack_public_path__ + "static/media/bottom-atomo.b88a0cf2.svg";
export { ForwardRef as ReactComponent };